import React from 'react';
import { Typography, List, ListItem, ListItemText } from '@mui/material';
import EDCRFAQ from './EdcrFAQ';

const FAQComponent = () => {
  return (
    <div style={{padding: '30px'}}>
      <Typography variant="h6" align="justify">Do You Know ?</Typography>
      <Typography variant="body1" align="justify">
        According to the provisions of the Uttar Pradesh Town and Country Planning Act, 1977 (Act No. 12 of 1977), no construction / development activity can be undertaken in any Planning / Special Area or deemed Planning Area without the prior permission of the competent Authority namely Director, Town and Country Planning, Uttar Pradesh. No local authority or any office or any officer or other authority shall, notwithstanding anything <a href="http://9app.net.in">9apps</a> contained in any other law for the time being in force, grant permission for the change in use of land without the permission in writing of the Director.
      </Typography>
      <EDCRFAQ />
      <Typography variant="body1" align="justify" style={{marginTop: '10px'}}>
      No Registrar or the Sub-Registrar, appointed under the Indian Registration Act, 1908, shall register any deed or document of transfer of any sub-division of land by way of sale, gift, exchange, lease or mortgage with possession, unless the sub-division of land is duly approved by the Director, subject to such rules as may be framed in this behalf by the State Government.
      </Typography>
    <List component="ol" style={{ listStyleType: 'lower-roman' }}>
      <ListItem>
        <ListItemText>
          <Typography variant="body1" style={{ textAlign: 'justify' }}>
            i. Where the land is owned by a person and the transfer is made without involving any further divisions;
          </Typography>
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemText>
          <Typography variant="body1" style={{ textAlign: 'justify' }}>
           ii. where the partition/sub-division of land is made in a joint Hindu Family;
          </Typography>
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemText>
          <Typography variant="body1" style={{ textAlign: 'justify' }}>
           iii. Where the lease is made in relation to a part or whole of a building;
          </Typography>
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemText>
          <Typography variant="body1" style={{ textAlign: 'justify' }}>
           iv. Where the mortgage is made for procuring the loans for construction or improvements over the land either from the Government or from any other financial institution constituted or established under any law for the time being in force or recognized by the State Government.
          </Typography>
        </ListItemText>
      </ListItem>
    </List>
    <Typography variant="body1" align="justify" style={{marginTop: '10px'}}>
        No electricity, water or sewerage connections shall be given to any person within the Planning or Special Area constituted under the Act, unless a No Objection Certificate has been obtained by such person from the Director or the Special Area Development Authority.
    </Typography>
    <Typography variant="body1" align="justify" style={{marginTop: '10px'}}>
        Provided that the service providing authorities shall disconnect the service connections forthwith of a building or land, in case any deviations from the approved plan or unauthorized constructions is brought to the notice or such authorities by the Director or the officer vested with the powers of the Director.
    </Typography>
    <Typography variant="h6" align="justify" style={{marginTop: '10px', textDecoration: 'underline'}}>After approval of plan</Typography>
    <Typography variant="body1" align="justify">
    The following things should be kept in mind after approval of plan and during construction:-
    </Typography>
    <List component="ol" style={{ listStyleType: 'lower-roman' }}>
      <ListItem>
        <ListItemText>
          <Typography variant="body1" style={{ textAlign: 'justify' }}>
            i. Get the plot/ land demarcated through Revenue Department and fix pillars on all four corners of the plot. Also raise a boundary wall in order to get saved from any dispute with neighbours.
          </Typography>
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemText>
          <Typography variant="body1" style={{ textAlign: 'justify' }}>
           ii. Least cutting and <a href="http://install9apps.in" target="_blank" rel="noopener noreferrer">9apps install</a> and filling should be done.
          </Typography>
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemText>
          <Typography variant="body1" style={{ textAlign: 'justify' }}>
           iii. The site development as well as construction should be done strictly as per the approved map.
          </Typography>
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemText>
          <Typography variant="body1" style={{ textAlign: 'justify' }}>
           iv. Drainage, sewerage and parking provisions be ensured property.
          </Typography>
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemText>
          <Typography variant="body1" style={{ textAlign: 'justify' }}>
            v. Approach path or access should be developed at site.
          </Typography>
        </ListItemText>
      </ListItem>
    </List>
    <Typography variant="h6" align="justify" style={{marginTop: '10px', textDecoration: 'underline'}}>Documents to be submitted with applications</Typography>
    <Typography variant="body1" align="justify" style={{marginTop: '10px'}}>
    Documents to be submitted for planning permission and sub-division of land should be as per prescribed under Forms 11 and 12 respectively of Uttar Pradesh Town and Country Planning Rules, 2014.    
    </Typography>
    <Typography variant="h6" align="justify" style={{marginTop: '10px', textDecoration: 'underline'}}>Who should prepare the plan</Typography>
    <Typography variant="body1" align="justify" style={{marginTop: '10px'}}>
    Plan can be prepared by the professionals registered/empanelled under Appendix-10 of the Uttar Pradesh Town and Country Planning Rules, 2014.    
    </Typography>
      
      
      
      
      <Typography variant="h5">FAQ (Regarding Apartments and Colonies)</Typography>
      <Typography variant="h6" align="justify" style={{marginTop: '10px'}}>What is an apartment building?</Typography>
      <Typography variant="body1" align="justify" style={{marginTop: '10px'}}>
      “apartment” whether called block, chamber, dwelling unit, flat, lot, premises, suite, tenement, unit ,cottage or by any other name means a separate and self-contained part of any property including one or more rooms or enclosed spaces located on one or more floors or any part or parts thereof, in a building, or in a plot of land, used or intended to be used for residence, Office, shop, showroom, or godown or for carrying on any business, industry, occupation, profession or trade, or for any other type of independent use ancillary to the purpose specified above and with a direct exit to a public street, road or highway or to a common area leading to such street, road or highway and includes any garage or room whether or not adjacent to the building in which such apartment is located, provided by the promoter for the use by the allottee for parking any vehicle or as the case may be, for the residence of any domestic servant employed in such apartment;    
      </Typography>
      <Typography variant="body1" align="justify" style={{marginTop: '10px'}}>
      “building” includes any structure or erection, or part of a structure or erection, which is intended to be used for residential, industrial, commercial or other purposes, whether in actual use or not. However, for the purpose of apartment, building shall mean a building constructed on any land, containing more than eight apartments, or two or more buildings with a total of more than eight apartments or any existing building converted into more than eight apartments;     
      </Typography>
      <Typography variant="h6" align="justify" style={{marginTop: '10px'}}>What is a colony?</Typography>
    
      <List component="ol" style={{ listStyleType: 'lower-roman' }}>
      <ListItem>
        <ListItemText>
          <Typography variant="body1" style={{ textAlign: 'justify' }}>
            Any area of land comprising of 2500 or more than 2500 square metres of land contiguous divided or proposed to be divided into plots or apartments or building for residential, commercial or industrial including purpose including cyber city, cyber park purpose.          </Typography>
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemText>
          <Typography variant="body1" style={{ textAlign: 'justify' }}>
          Except:-
         </Typography>
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemText>
          <Typography variant="body1" style={{ textAlign: 'justify' }}>
          Family partition by way inheritance or succession without a motive of earning profit.          
          </Typography>
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemText>
          <Typography variant="body1" style={{ textAlign: 'justify' }}>
          Earmarked by a factory owner for housing colony for his employees or labourers.          
          </Typography>
        </ListItemText>
      </ListItem>
    </List>

    <Typography variant="h6" align="justify" style={{marginTop: '10px'}}>Who is a Promoter or can become a Promoter under TCP Act?</Typography>
    <Typography variant="body1" align="justify" style={{marginTop: '10px'}}>
     Any individual, Firm, Company, Co-operative Society & Association of Persons, who constructs/causes to construct a building consisting more than eight apartments or sets up/causes to set up a colony over land having area of 2500 or more than 2500 square meters for selling purpose.    
     </Typography>

    <Typography variant="h6" align="justify" style={{marginTop: '10px'}}>Who is a Estate Agent or can become a Estate Agent under TCP Act?</Typography>
    <Typography variant="body1" align="justify" style={{marginTop: '10px'}}>
    “estate agent” means a person who negotiates or acts on behalf of a person in a transaction of transfer of property whether by way of sale, lease, license, mortgage or otherwise with another person and receives remuneration for his services in the form of commission and includes a person who introduces to each other for negotiation such persons or their agents.
     </Typography>

     <Typography variant="h6" align="justify" style={{marginTop: '10px'}}>What are the requirements to become a Promoter under TCP Act?</Typography>
    <Typography variant="body1" align="justify" style={{marginTop: '10px'}}>
    One can apply online for Registration as Promoter fulfilling the following requirements:-
    </Typography>

    <List component="ul">
      <ListItem>
        <ListItemText>
          <Typography variant="body1" style={{ textAlign: 'justify' }}>
            Self Certified Statement regarding fulfilling the following requirements:
          </Typography>
          <List component="ul" style={{ listStyleType: 'none' }}>
            <ListItem>
              <ListItemText>
                <Typography variant="body1" style={{ textAlign: 'justify' }}>
                  &gt; Should not be less than 18 years.
                </Typography>
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemText>
                <Typography variant="body1" style={{ textAlign: 'justify' }}>
                  &gt; Any individual or one of his employees should have 5 years experience in the field and should have a degree in engineering, architecture or town planning or should be a class-A contractor.
                </Typography>
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemText>
                <Typography variant="body1" style={{ textAlign: 'justify' }}>
                  &gt; Should not be of unsound mind, un-discharged insolvent, blacklisted entity, or have been convicted of an offence.
                </Typography>
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemText>
                <Typography variant="body1" style={{ textAlign: 'justify' }}>
                  &gt; Should not be an employee or should not have been dismissed or removed from the Government or Local Authority.
                </Typography>
              </ListItemText>
            </ListItem>
          </List>
        </ListItemText>
      </ListItem>
    </List>

    <Typography variant="h6" align="justify" style={{marginTop: '10px', textDecoration: 'underline'}}>Other documents</Typography>
    <List component="ul">
      <ListItem>
        <ListItemText>
          <Typography variant="body1" style={{ textAlign: 'justify' }}>
            &gt; Statement of Assets and Liabilities duly certified by Registered Chartered Accountant.
          </Typography>
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemText>
          <Typography variant="body1" style={{ textAlign: 'justify' }}>
            &gt; Registration Certificate from RoC or Partnership deed etc.
          </Typography>
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemText>
          <Typography variant="body1" style={{ textAlign: 'justify' }}>
            &gt; Copy of Pan Card.
          </Typography>
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemText>
          <Typography variant="body1" style={{ textAlign: 'justify' }}>
            &gt; Three years Income Tax Returns of proceeding 3 years.
          </Typography>
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemText>
          <Typography variant="body1" style={{ textAlign: 'justify' }}>
            &gt; Details of previous projects executed in preceding 5 years.
          </Typography>
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemText>
          <Typography variant="body1" style={{ textAlign: 'justify' }}>
            &gt; An undertaking to appoint a qualified person.
          </Typography>
        </ListItemText>
      </ListItem>
    </List>

    <Typography variant="h6" align="justify" style={{marginTop: '10px', textDecoration: 'underline'}}>What are the requirements to become an Estate Agent under TCP Act?</Typography>
    <Typography variant="body1" style={{ textAlign: 'justify' }}>
    One can apply online for Registration as Estate Agent fulfilling the following requirements:-    
    </Typography>
    <List component="ul">
      <ListItem>
        <ListItemText>
          <Typography variant="body1" style={{ textAlign: 'justify' }}>
            &gt; Any individual or one of his employees should have atleast one year experience as an Estate Agent.
          </Typography>
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemText>
          <Typography variant="body1" style={{ textAlign: 'justify' }}>
            &gt; Income Tax Returns for the last three years alongwith attested copy of Permanent Account Number (PAN).
          </Typography>
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemText>
          <Typography variant="body1" style={{ textAlign: 'justify' }}>
            &gt; Self certified statement regarding conditions on following points:-
            <ul>
              <ListItem>
                <ListItemText>
                  <Typography variant="body1" style={{ textAlign: 'justify' }}>
                    &gt; Should not be less than eighteen years of age.
                  </Typography>
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemText>
                  <Typography variant="body1" style={{ textAlign: 'justify' }}>
                    &gt; Should not be in the employment of the Government or a State undertaking or a Local Authority.
                  </Typography>
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemText>
                  <Typography variant="body1" style={{ textAlign: 'justify' }}>
                    &gt; Should not be an un-discharged insolvent, un-sound mind or a convicted person.
                  </Typography>
                </ListItemText>
              </ListItem>
            </ul>
          </Typography>
        </ListItemText>
      </ListItem>
    </List>

    <Typography variant="h6" align="justify" style={{marginTop: '10px', textDecoration: 'underline'}}>What is the fee payable for getting registered as a Promoter?</Typography>
    <List component="ol">
      <ListItem>
        <ListItemText>
          <Typography variant="body1" style={{ textAlign: 'justify' }}>
            1. Registration Fee Rs 50,000 through e-challan or challan or as DD in favour of Director (TCP).
          </Typography>
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemText>
          <Typography variant="body1" style={{ textAlign: 'justify' }}>
            2. Security (Refundable) Rs 1.00 lacs as Bank Guarantee or FD duly pledged in the name of Director (TCP).
          </Typography>
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemText>
          <Typography variant="body1" style={{ textAlign: 'justify' }}>
            3. E-charge fee Rs. 1500/- through DD in favour of Director (TCP).
          </Typography>
        </ListItemText>
      </ListItem>
    </List>

    <Typography variant="h6" align="justify" style={{marginTop: '10px', textDecoration: 'underline'}}>What is the fee payable for getting registered as an Estate Agent?</Typography>
    <List component="ol">
      <ListItem>
        <ListItemText>
          <Typography variant="body1" style={{ textAlign: 'justify' }}>
            1. Registration Fee Rs 10,000 through e-challan or challan or as DD in favour of Director (TCP).
          </Typography>
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemText>
          <Typography variant="body1" style={{ textAlign: 'justify' }}>
            2. Security (Refundable) Rs 25,000/-only as Bank Guarantee or FD duly pledged in the name of Director (TCP).
          </Typography>
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemText>
          <Typography variant="body1" style={{ textAlign: 'justify' }}>
            3. E-charge fee Rs. 750/- through DD in favour of Director (TCP).
          </Typography>
        </ListItemText>
      </ListItem>
    </List>

    <Typography variant="h6" align="justify" style={{marginTop: '10px', textDecoration: 'underline'}}>How can I get a licence to develop a colony?</Typography>
    <List component="ol">
      <ListItem>
        <ListItemText>
          <Typography variant="body1" style={{ textAlign: 'justify' }}>
            1. The person/AOP/Firm/Company should have been registered as Promoter under H.P. TCP Act.
          </Typography>
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemText>
          <Typography variant="body1" style={{ textAlign: 'justify' }}>
            2. The land should be in the name of person/ AOP/ Firm/ Company.
          </Typography>
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemText>
          <Typography variant="body1" style={{ textAlign: 'justify' }}>
            3. Application Form -47 (Rule-51).
          </Typography>
        </ListItemText>
      </ListItem>
    </List>

    <Typography variant="h6" align="justify" style={{marginTop: '10px', textDecoration: 'underline'}}>What are the steps involved for grant of licence to develop a colony?</Typography>
    <List component="ol">
      <ListItem>
        <ListItemText>
          <Typography variant="body1" style={{ textAlign: 'justify' }}>
            1. Applicant should be a registered Promoter under H.P. Town and Country Planning Act, 1977.
          </Typography>
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemText>
          <Typography variant="body1" style={{ textAlign: 'justify' }}>
            2. He has to submit the case for grant of licence as per Form-47 with relevant documents and Licence fee.
          </Typography>
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemText>
          <Typography variant="body1" style={{ textAlign: 'justify' }}>
            3. The documents/cases are scrutinized by the Department and after getting approval of plans/drawings, from the concerned authorities, the case is placed before the Committee constituted by Govt. for scrutinizing the cases pertaining to Apartments.
          </Typography>
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemText>
          <Typography variant="body1" style={{ textAlign: 'justify' }}>
            4. As per the recommendation of Committee the Director passes an order under Section 78 (p) (2) of the Act to call upon the Promoter to fulfill the conditions laid down in Rule-53 within 30 days from the issuance of the Notice in Form-48.
          </Typography>
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemText>
          <Typography variant="body1" style={{ textAlign: 'justify' }}>
            5. If promoter fails to fulfill the conditions within specified /extended period, the grant of licence shall be refused.
          </Typography>
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemText>
          <Typography variant="body1" style={{ textAlign: 'justify' }}>
            6. The Promoter who is found fit for grant of Licence under sub-section (2) of Section 78p of the Act shall be asked by the Director to:-
          </Typography>
        </ListItemText>
      </ListItem>
      <ul>
        <ListItem>
          <ListItemText>
            <Typography variant="body1" style={{ textAlign: 'justify' }}>
              &gt; Furnish an Undertaking to enter into an agreement in Form-50 for carrying out the completion of development works in accordance with the conditions of the Licence to be granted.
            </Typography>
          </ListItemText>
        </ListItem>
        <ListItem>
          <ListItemText>
            <Typography variant="body1" style={{ textAlign: 'justify' }}>
              &gt; Deposit Development charges assessed @ Rs. 200/- per sqm. of plot area in shape of Bank Draft.
            </Typography>
          </ListItemText>
        </ListItem>
      </ul>
    </List>

    <Typography variant="h6" align="justify" style={{marginTop: '10px'}}>Where can a colony be developed in H.P.?</Typography>
    <Typography variant="body1" style={{ textAlign: 'justify' }}>
        Anywhere in Uttar Pradesh, subject to the fulfillment of requirements prescribed under Appendix-7 of the H.P. Town and Country Planning Rules, 2014 or Development Plans/ Interim Development Plans.    
    </Typography>
    <Typography variant="h6" align="justify" style={{marginTop: '10px'}}>Can a non-himachali or a non-agriculturist himachali buy an apartment or plot in H.P.?</Typography>
    <Typography variant="body1" style={{ textAlign: 'justify' }}>
    Yes, after taking permission from the Government under Section-118 of H.P. Tenancy and Land Reforms Act, 1972.    
    </Typography>
    <Typography variant="h6" align="justify" style={{marginTop: '10px'}}>What is the implication of Section-118 of H.P. Tenancy and Land Reforms Act, 1972 with reference to apartments?</Typography>
    <Typography variant="body1" style={{ textAlign: 'justify' }}>
    Transfer of land to non-agriculturist is barred under Section-118 under which following steps are involved:-
    </Typography>
    <List component="ol">
      <ListItem>
        <ListItemText>
          <Typography variant="body1" style={{ textAlign: 'justify' }}>
            1. Essentiality Certificate.
          </Typography>
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemText>
          <Typography variant="body1" style={{ textAlign: 'justify' }}>
            2. Permission under Section-118 required for purchase of land.
          </Typography>
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemText>
          <Typography variant="body1" style={{ textAlign: 'justify' }}>
            3. Permission for selling the apartments under Section-118 to non-agriculturist Himachalis and non-Himachalis.
          </Typography>
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemText>
          <Typography variant="body1" style={{ textAlign: 'justify' }}>
            4. Permission required for purchasing the apartments or plots by non-himachali or a non-agriculturist himachali.
          </Typography>
        </ListItemText>
      </ListItem>
    </List>
    <Typography variant="h6" align="justify" style={{marginTop: '10px'}}>Where shall I apply for grant of registration as an Estate Agent or a Promoter?</Typography>
    <Typography variant="body1" style={{ textAlign: 'justify' }}>
        The applicant should apply for registration as an Estate Agent in the Directorate Office under online system.
    </Typography>

    </div>
  );
};

export default FAQComponent;
